import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // This is called from Rails controllers using Concern::TurboDrive#copy_to_clipboard

  // Rails inserts
  // <div data-controller="copy-to-clipboard"
  //      data-copy-to-clipboard-text-value="…"></div>
  static values = { text: String }

  connect() {
    navigator.clipboard
      .writeText(this.textValue)
      .finally(() => this.element.remove())
  }
}
